import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add resource hints for performance
if (typeof window !== 'undefined') {
  // Preconnect to Google Fonts
  const preconnectGoogleFonts = document.createElement('link');
  preconnectGoogleFonts.rel = 'preconnect';
  preconnectGoogleFonts.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnectGoogleFonts);
  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectGstatic);
  // DNS prefetch for CDN
  const dnsPrefetchCDN = document.createElement('link');
  dnsPrefetchCDN.rel = 'dns-prefetch';
  dnsPrefetchCDN.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(dnsPrefetchCDN);
  // DNS prefetch for Facebook
  const dnsPrefetchFB = document.createElement('link');
  dnsPrefetchFB.rel = 'dns-prefetch';
  dnsPrefetchFB.href = 'https://connect.facebook.net';
  document.head.appendChild(dnsPrefetchFB);
  // Preload LCP image (WebP for better performance)
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = 'https://cdn.magicpatterns.com/uploads/cJGzsbT4NRJ27eXKnkWyh3/mockup_sin_fondo_webp.png';
  preload.type = 'image/webp';
  (preload as any).fetchPriority = 'high';
  document.head.appendChild(preload);
}
render(<App data-id="element-308" />, document.getElementById('root'));